import { GtagService } from 'src/app/gtag/gtag.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TimeoutError } from 'rxjs';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { ErrorsService } from '../../../shared/services/errors.service';

@Component({
  selector: 'hs-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


  @Input() redirect = true;
  @Output() cartLoggedIn = new EventEmitter<Boolean>();


  public form: FormGroup;
  private returnUrl: string;

  public loading = false;
  public submitted = false;
  public authError = false;
  public timeoutError = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService,
    private formBuilder: FormBuilder,
    private utils: UtilsService,
    private gtag: GtagService,
    private errorsService: ErrorsService
  ) {
    // Redirect to home if already logged in
    if (this.auth.currentUser) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    const returnUrlParam = 'returnUrl';
    this.returnUrl = this.route.snapshot.queryParams[returnUrlParam] || '/';
    this.form = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', [Validators.required]],
      rememberMe: [true]
    });
  }

  get f() {
    return this.form.controls;
  }

  login() {
    this.submitted = true;
    this.authError = false;
    this.timeoutError = false;
    if (this.form.invalid) {
      return;
    }
    this.loading = true;
    this.form.disable();
    this.auth.login(
      this.form.value.username,
      this.form.value.password,
      // this.form.value.rememberMe returns true if rememberMe is selected, otherwise it returns false
      // tslint:disable-next-line
      this.form.value.rememberMe == true
    ).subscribe(response => {
      if(this.redirect) {
        this.router.navigateByUrl(this.returnUrl);
      }
      this.cartLoggedIn.emit(true);
      this.gtag.login('email');
    }, error => {
      
      if (error instanceof TimeoutError) {
        this.timeoutError = true;
      } else {
        this.gtag.passwordError();
        this.authError = true;
      }
      this.loading = false;
      this.submitted = false;
      this.f.password.setValue('');
      this.form.enable();
      this.cartLoggedIn.emit(false);
      
      this.errorsService.track(error);
    });
  }

}
